"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _d3Geo = require("d3-geo");

var _countryCoder = require("@ideditor/country-coder");

var _reactSimpleMaps = require("react-simple-maps");

var _allstates = _interopRequireDefault(require("./data/allstates.json"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _ = require("../..");

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

var _GameSummary = require("../../molecules/GameSummary");

var _helpers = require("../../util/helpers");

require("./USMap.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
var offsets = {
  VT: [50, -8],
  NH: [34, 2],
  MA: [30, -1],
  RI: [28, 2],
  CT: [35, 10],
  NJ: [34, 1],
  DE: [33, 0],
  MD: [47, 10],
  DC: [49, 21]
};

var USMap = /*#__PURE__*/function (_Component) {
  _inherits(USMap, _Component);

  var _super = _createSuper(USMap);

  function USMap(props) {
    var _this;

    _classCallCheck(this, USMap);

    _this = _super.call(this, props);
    _this.state = {
      compressed: [[], null, null, null, null, null, null],
      zoom: 1,
      zoomCenter: undefined,
      tooltip: "",
      currentIdx: 0
    };
    return _this;
  }

  _createClass(USMap, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.data !== this.props.data && this.props.data.length) {
        var data = [];
        /* Check if coordinates are inside US */

        this.props.data.forEach(function (item) {
          if ((0, _countryCoder.iso1A2Code)([item.lon, item.lat]) === 'US') {
            data.push(item);
          }
        });
        var compressed = [];

        for (var i = 0; i < 7; i++) {
          var factor = 0.47 - 0.3 * i / 4.0;
          var zoomed = this.generateCompressedData(data, factor);
          compressed.push(zoomed);
        }

        this.setState({
          currentIdx: 0,
          compressed: compressed
        });
        this.startAnimation();
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this2 = this;

      this.timer = setTimeout(function () {
        var nextIdx = _this2.state.currentIdx + 1;

        if (nextIdx < _this2.props.data.length) {
          _this2.setState({
            currentIdx: nextIdx
          });

          _this2.startAnimation();
        } else if (nextIdx >= _this2.props.data.length) {
          nextIdx = _this2.props.data.length - 1;

          _this2.setState({
            currentIdx: nextIdx
          });
        }
      }, 25);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      var id = parseInt(e.target.id.split('-')[1], 10);
      var entry = this.getData().find(function (item) {
        return item.game_id === id;
      });
      this.setState({
        tooltip: entry
      });
      if (this.props.tooltipChanged) this.props.tooltipChanged(entry);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e) {
      this.setState({
        tooltip: null
      });
      if (this.props.tooltipChanged) this.props.tooltipChanged(null);
    }
  }, {
    key: "matchDataTransform",
    value: function matchDataTransform(data) {
      return data.map(function (match) {
        return {
          'home_team_jersey_color': match.home_team_jersey_color,
          'home_team_title': match.team_title,
          'home_team_score': match.home_team_score,
          'away_team_jersey_color': match.away_team_jersey_color,
          'away_team_title': match.away_team_title,
          'away_team_score': match.away_team_score,
          'full_date': match.full_date,
          'home_team_slug': match.team_slug,
          'game_id': match.game_id
        };
      });
    }
  }, {
    key: "onClick",
    value: function onClick(e, item) {
      e.preventDefault(); //is it a group of markers?

      if (item.cdata) {
        var matchesList = this.matchDataTransform(item.cdata.items);
        var lastMatch = {
          'home_team_jersey_color': item.home_team_jersey_color,
          'home_team_title': item.team_title,
          'home_team_score': item.home_team_score,
          'away_team_jersey_color': item.away_team_jersey_color,
          'away_team_title': item.away_team_title,
          'away_team_score': item.away_team_score,
          'full_date': item.full_date,
          'home_team_slug': item.team_slug,
          'game_id': item.game_id
        };
        matchesList.push(lastMatch);
        this.props.history.push({
          pathname: this.props.gamesListPageUrl,
          state: {
            games: matchesList,
            loading: false
          }
        });
        return;
      }

      (0, _.trk)("USMap:Marker Clicked:Game:".concat(item.game_id), true);
      var utmCodes = (0, _helpers.composeUtmCodes)(this.props.utmCampaign, this.props.utmSource, this.props.utmMedium);
      var link = "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(item.team_slug, "/games/").concat(item.game_id, "/touch-chains/first").concat(utmCodes);
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href: link
      }).click();
    }
  }, {
    key: "calcRadius",
    value: function calcRadius(item, factor) {
      return Math.min(16, 8 + item.cdata.items.length / 2);
    }
  }, {
    key: "isInRange",
    value: function isInRange(item1, item2, factor) {
      return Math.pow(item1.lon - item2.lon, 2) + Math.pow(item1.lat - item2.lat, 2) < factor;
    }
  }, {
    key: "checkAround",
    value: function checkAround(group, item, factor) {
      var around = this.isInRange(group, item, factor);

      if (!around && group.cdata) {
        for (var j = 0; j < group.cdata.items.length && !around; j++) {
          around |= this.isInRange(group.cdata.items[j], item, factor);
        }
      }

      if (around) {
        if (!group.cdata) {
          group.cdata = {
            items: [item]
          };
        } else group.cdata.items.push(item);

        group.highlighted |= item.highlighted;
      }

      return around;
    }
  }, {
    key: "generateCompressedData",
    value: function generateCompressedData(data) {
      var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.47;
      var ret = [];

      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var found = false;
        item.radius = 8;
        item.highlighted = i < 25;
        item = _objectSpread({}, item);

        for (var j = 0; j < ret.length; j++) {
          if (this.checkAround(ret[j], item, factor)) {
            found = true;
            break;
          }
        }

        if (found) continue;
        ret.push(item);
      }

      for (var _i = 0, _ret = ret; _i < _ret.length; _i++) {
        var _item = _ret[_i];

        if (_item.cdata) {
          _item.radius = this.calcRadius(_item, factor);
        }
      }

      return ret;
    }
  }, {
    key: "getData",
    value: function getData() {
      var zoom = Math.round(this.state.zoom);
      return this.state.compressed[zoom - 1];
    }
  }, {
    key: "getGameMarkers",
    value: function getGameMarkers() {
      var _this3 = this;

      var markerFillColor = "rgba(55,194,172,0.5)";
      var markerFillColorBaseball = "rgba(255, 10, 10, 0.6)";
      var data = this.getData();
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data && this.state.currentIdx >= data.length - 1 && data.slice(0, 25).filter(function (item) {
        return item.highlighted;
      }).map(function (item, index) {
        var isBaseball = item.video_render_type.includes("baseball") || item.sport_type !== 'soccer';
        return /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Marker, {
          key: item.game_id + '-marker',
          coordinates: [item.lon, item.lat]
        }, /*#__PURE__*/_react.default.createElement("circle", {
          r: item.radius / _this3.state.zoom,
          fill: !isBaseball ? markerFillColor : markerFillColorBaseball,
          fillOpacity: 1,
          id: "marker-".concat(item.game_id),
          style: {
            zIndex: 10
          }
        }, /*#__PURE__*/_react.default.createElement("animate", {
          attributeName: "fill-opacity",
          values: "1;0",
          dur: "1.5s",
          keyTimes: "0;1",
          begin: "0",
          repeatCount: "indefinite"
        }), /*#__PURE__*/_react.default.createElement("animateTransform", {
          attributeName: "transform",
          type: "scale",
          from: "1 1",
          to: "4 4",
          begin: "0",
          dur: "1.5s",
          repeatCount: "indefinite"
        })));
      }), data && data.slice(0, this.state.currentIdx + 1).map(function (item, index) {
        var isBaseball = item.video_render_type.includes("baseball") || item.sport_type !== 'soccer';
        return /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Marker, {
          key: "".concat(item.game_id, "-marker"),
          coordinates: [item.lon, item.lat]
        }, /*#__PURE__*/_react.default.createElement("circle", {
          r: item.radius / _this3.state.zoom,
          fill: !isBaseball ? markerFillColor : markerFillColorBaseball,
          fillOpacity: 1,
          id: "marker-".concat(item.game_id),
          style: {
            cursor: 'pointer',
            zIndex: 11
          },
          onMouseEnter: function onMouseEnter(e) {
            _this3.onMouseEnter(e);
          },
          onMouseLeave: function onMouseLeave(e) {
            _this3.onMouseLeave(e);
          },
          onClick: function onClick(e) {
            _this3.onClick(e, item);
          }
        }));
      }));
    }
  }, {
    key: "getStateMarkers",
    value: function getStateMarkers(geographies) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, geographies.map(function (geo) {
        return /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Geography, {
          key: geo.rsmKey,
          stroke: "#CACCCC",
          geography: geo,
          fill: "#FFFFFF",
          style: {
            default: {
              fill: "#FFFFFF",
              outline: "none"
            },
            hover: {
              fill: "#FFFFFF",
              outline: "none"
            },
            pressed: {
              fill: "#FFFFFF",
              outline: "none"
            }
          }
        });
      }), geographies.map(function (geo) {
        var centroid = (0, _d3Geo.geoCentroid)(geo);

        var cur = _allstates.default.find(function (s) {
          return s.val === geo.id;
        });

        return /*#__PURE__*/_react.default.createElement("g", {
          key: geo.rsmKey + "-name"
        }, cur && centroid[0] > -160 && centroid[0] < -67 && (Object.keys(offsets).indexOf(cur.id) === -1 ? /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Marker, {
          coordinates: centroid
        }, /*#__PURE__*/_react.default.createElement("text", {
          y: "2",
          fontSize: 14,
          textAnchor: "middle",
          fill: "#666",
          style: {
            cursor: "default"
          }
        }, cur.id)) : /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Annotation, {
          subject: centroid,
          dx: offsets[cur.id][0],
          dy: offsets[cur.id][1],
          connectorProps: {
            stroke: "#666",
            strokeWidth: 1
          }
        }, /*#__PURE__*/_react.default.createElement("text", {
          x: 4,
          fontSize: 14,
          alignmentBaseline: "middle",
          fill: "#666"
        }, cur.id))));
      }));
    }
  }, {
    key: "getTooltipBody",
    value: function getTooltipBody() {
      var tip = this.state.tooltip;
      var scoreItem = tip ? {
        full_date: tip.full_date,
        meta: {
          home_team: {
            name: tip.team_title,
            color_value: tip.home_team_jersey_color,
            score: tip.home_team_score
          },
          away_team: {
            name: tip.away_team_title,
            color_value: tip.away_team_jersey_color,
            score: tip.away_team_score
          }
        }
      } : {};
      if (tip && !tip.cdata) return /*#__PURE__*/_react.default.createElement(_GameSummary.GameSummary, {
        homeTeamStyle: scoreItem.meta.home_team.color_value,
        homeTeamName: scoreItem.meta.home_team.name,
        homeTeamScore: scoreItem.meta.home_team.score,
        awayTeamStyle: scoreItem.meta.away_team.color_value,
        awayTeamName: scoreItem.meta.away_team.name,
        awayTeamScore: scoreItem.meta.away_team.score,
        showTime: true,
        diffDates: scoreItem.full_date
      });
      if (tip && tip.cdata) return /*#__PURE__*/_react.default.createElement("div", {
        className: "group-tip"
      }, /*#__PURE__*/_react.default.createElement("div", null, "Group of ", tip.cdata.items.length + 1, " games"), /*#__PURE__*/_react.default.createElement("div", null, "Click to see a full list"));
      return null;
    }
  }, {
    key: "onZoomChange",
    value: function onZoomChange(e) {
      var idx = this.state.currentIdx;

      if (this.state.zoom !== e.zoom) {
        idx = this.props.data.length - 1;
        if (this.timer) clearTimeout(this.timer);
        this.timer = null;
      }

      this.setState({
        zoom: e.zoom >= 7 ? 7 : e.zoom,
        zoomCenter: e.coordinates,
        currentIdx: idx
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, null, /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.ComposableMap, {
        "data-tip": "",
        projection: "geoAlbersUsa"
      }, /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.ZoomableGroup, {
        zoom: this.state.zoom,
        center: this.state.zoomCenter,
        onMoveEnd: function onMoveEnd(e) {
          _this4.onZoomChange(e);
        }
      }, /*#__PURE__*/_react.default.createElement(_reactSimpleMaps.Geographies, {
        geography: geoUrl
      }, function (_ref) {
        var geographies = _ref.geographies;
        return _this4.getStateMarkers(geographies);
      }), this.getGameMarkers())), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
        className: "map-tooltip",
        backgroundColor: "#ffffff",
        border: true,
        borderColor: "rgba(0, 0, 0, 0.15)"
      }, this.getTooltipBody()));
    }
  }]);

  return USMap;
}(_react.Component);

var _default = (0, _reactRouter.withRouter)(USMap);

exports.default = _default;